(() => {
  const propertyName = 'Pre-order dispatch';
  let running = false;
  let queued = false;

  const cartChangeUrl = () =>
    window.routes?.cart_change_url || `${window.Shopify?.routes?.root || '/'}cart/change.js`;

  const readRows = () => {
    const byIndex = new Map();
    document.querySelectorAll('[data-preorder-reconcile]').forEach((row) => {
      const index = Number(row.dataset.lineIndex);
      if (!index || byIndex.has(index)) return;

      let properties = {};
      try {
        properties = JSON.parse(row.dataset.lineProperties || '{}') || {};
      } catch (error) {
        console.warn('Could not read pre-order cart properties.', error);
        return;
      }

      const desired = row.dataset.preorderDispatch || '';
      const current = properties[propertyName] || '';
      if (current === desired) return;

      if (desired) properties[propertyName] = desired;
      else delete properties[propertyName];

      byIndex.set(index, {
        line: index,
        quantity: Number(row.dataset.lineQuantity) || 1,
        properties,
      });
    });
    return [...byIndex.values()].sort((a, b) => b.line - a.line);
  };

  const reconcile = async () => {
    if (running) {
      queued = true;
      return;
    }

    const changes = readRows();
    if (!changes.length) return;
    running = true;

    try {
      let cartData;
      for (const change of changes) {
        const response = await fetch(cartChangeUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(change),
        });
        if (!response.ok) throw new Error(`Cart update failed (${response.status})`);
        cartData = await response.json();
      }

      if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'preorder-reconcile', cartData });
      }
    } catch (error) {
      console.warn('Could not refresh pre-order details in the cart.', error);
    } finally {
      running = false;
      if (queued) {
        queued = false;
        window.setTimeout(reconcile, 100);
      }
    }
  };

  let timer;
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, 120);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
